var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box container"},[_c('h1',{staticClass:"is-size-3"},[_vm._v("Personal Ability")]),_c('hr'),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.markdown)}}),_c('div',{staticClass:"widgets"})])}
var staticRenderFns = []

export { render, staticRenderFns }